import { Component, OnInit } from '@angular/core';
import { AdminApiService, ContactRequestAdmin } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-contact-requests',
    templateUrl: './admin-contact-requests.component.html'
})
export class AdminContactRequestsComponent implements OnInit {

    requests: ContactRequestAdmin[] = [];
    selected: ContactRequestAdmin | null = null;

    loading = false;
    errorMessage = '';
    successMessage = '';

    constructor(private adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.getRequests();
    }

    getRequests(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getContactRequests().subscribe(
            (data: ContactRequestAdmin[]) => {
                this.requests = data || [];
                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Contact requests could not be loaded.';
                this.loading = false;
            }
        );
    }

    view(item: ContactRequestAdmin): void {
        this.selected = item;
        this.successMessage = '';
        this.errorMessage = '';
    }

    updateStatus(item: ContactRequestAdmin, status: string): void {
        this.adminApi.updateContactRequestStatus(item.id, status).subscribe(
            () => {
                item.status = status;

                if (this.selected && this.selected.id === item.id) {
                    this.selected.status = status;
                }

                this.successMessage = 'Status updated.';
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Status could not be updated.';
            }
        );
    }
}